export default function Color (pButton)
{
  const selectColorButton = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAVCAMAAADhGEdVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAThQTFRF0tLS7u7u8PDw1NTU8fHx7Ozs1dXV6urq6enp////rq6u3t7e19fX5+fn3Nzc2dnZ5eXl4uLiUVFR4ODgU1NT29vb09PTxcXF4eHhUlJSycnJ7e3ttbW1z8/Pbm5uw8PDd3d3Wlpatra2ZGRkZWVlXFxcy8vLi4uLdnZ2wsLC0NDQrKys1tbW2traxMTEgICAyMjIn5+fdXV1vr6+W1tbxsbGlpaWnJycx8fH39/fvLy8+vr66+vr5ubm7+/v4+Pj0dHReXl5bW1tvb298vLyzs7OoaGh9vb2eHh4Y2NjiYmJl5eXwcHBv7+/q6uriIiIgYGBsbGxsLCwnZ2dp6enc3NzjIyMoqKikpKS5OTkhYWFysrK3d3dpaWlmZmZu7u7h4eHb29vlJSUubm5s7Oz2NjYioqK////h4nf7wAAAGh0Uk5T/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////wAf7P1LAAABpklEQVR42pTTx5abMBSAYRmYQKJBEkKI7t7Gbdyn957ee29+/zfIBTM5WWSBv4Ukrv5zOCxACw33UD49rC2Qohp7d/PZM9RD1N+/OtfyOb/ap+j4UFnBMUKFVcBXrK0Cej1zMfBuj/poXf8/6I3Uy4YQomVkxMD41/dntyfozQRuXGpadQ4nVYVFDGDZwOkNbCcjMwM9S3wQXxjT15jcFKJImCixT/VGY4uR+/BamIlymjHorQT75p8+6VrW22vTrHct/6E1nSjR1OrWpRbRk0stTDMLejtViOZF/6tdq4/H003bf/TTb4/L/m759ZF9YF2/sDPQ4yVmhA84rs1dd3iB+aTKXdcN+sXfyV15K4sw9CTx432TNNs1Mjr95cW7hJ8dVT573uNm62aDPG+22iQDvZOYVTjntY4jn8L+xuFnzuSG80qpV4TnUqnCX6WZAz1NYEUGsoAp0c3g4zuq7VCvIAMFk1AGJt45CLw0owh11pcIJulOcf/vZLnSZEiXsw4aqnfyU4doO5ZqXjLeRkZ1Fuf8H+NZ1UCL0I3u5RO54eKPAAMArcU+q6MMY8kAAAAASUVORK5CYII=';


  const initColorDropdownComponents = () =>
  {
    const dropdown = pButton.pAttribute.Dropdown;

    if (dropdown.isObjValid)
    {
      this.setColorDropdownThemeColors();

      if (pButton.pGroup.pToolbar.isLocalToolbar)
      {
        BEditor.LocalToolbarDropdowns.push(
        {
          'dropdown': dropdown,
          'handlerShowed': pButton.pThis.refreshState,
          'handlerHidden': pButton.restoreEditorRange
        });
      }

      dropdown.DropDownShowed.addHandler(pButton.pThis.refreshState);
      dropdown.DropDownHidden.addHandler(pButton.restoreEditorRange);
    }
    else
    {
      setTimeout(initColorDropdownComponents, 137);
    }
  };


  const renderColorsTable = (colorValues, colorIds) =>
  {
    const transparentBg = 'transparent url(data:image/gif;base64,R0lGODlhDwAPAIABAL+/v////yH5BAEAAAEALAAAAAAPAA8AAAInhI9pwe1x4HMAVjnvYrf1zXlUF5JWlpmVSn6jSHnahC1mHNGywhsFADs=) 0 0 no-repeat';

    let tableHTML = '<div style="overflow: hidden; clear: both;">';

    for (let i = 0; i < colorValues.length; i++)
    {
      for (let n = 0; n < colorValues[i].length; n++)
      {
        tableHTML += '<div ddtype="Item" ddsubtype="ColorCell" ddvalue="' + ((colorIds[i][n].toUpperCase() === 'TTTTTT') ? 'transparent' : colorIds[i][n]) + '" style="width: 15px; height: 15px; overflow: hidden; ' + (n ? '' : 'clear: left;') + 'float: left; margin: 0 1px 1px 0; background: ' + ((colorValues[i][n].toUpperCase() === 'TTTTTT') ? transparentBg : '#' + colorValues[i][n]) + '; font-size: 0; cursor: crosshair;"></div>';
      }
    }

    return tableHTML + '</div>';
  };


  this.preInitForeColorDropdownButton = (isNewTheme) =>
  {
    const foreColors = editorToolbarColorsTable,
          foreColorIds = editorToolbarColorsTable;

    let dropdownInnerHTML;

    pButton.pAttribute.parameters.themeColorsContainerId = 'idForeColorDropdownThemeColorsContainer';

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="position: relative; width: 289px; overflow: hidden; padding: 10px 8px 10px 10px; background-color: #F5F5F5; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: normal; font-style: normal; text-decoration: none;">';

    dropdownInnerHTML += '  <div id="' + pButton.pAttribute.parameters.themeColorsContainerId + '" style="overflow: hidden;">';
    dropdownInnerHTML += '    <div style="width: 87px; overflow: hidden; float: left; padding-top: 1px;">' + ((pButton.pAttribute.name === 'ForeColorEmail') ? 'Email colors' : 'Theme colors') + '</div>';

    for (let i = 0; i < 12; i++)
    {
      dropdownInnerHTML += '  <div ddtype="Item" ddsubtype="ColorCell" ddvalue="" style="width: 15px; height: 15px; overflow: hidden; float: left; visibility: hidden; margin: 0 1px 1px 0; background: transparent; font-size: 0; cursor: crosshair;"></div>';
    }

    dropdownInnerHTML += '  </div>';

    dropdownInnerHTML += '<div id="' + pButton.pAttribute.parameters.themeColorsContainerId + '_Separator" style="height: 19px; overflow: hidden; margin: 0 -10px; background: transparent url(data:image/gif;base64,R0lGODlhAgABAIABALOzs////yH5BAEAAAEALAAAAAACAAEAAAICDAoAOw==) 0 8px repeat-x;"></div>';

    dropdownInnerHTML += renderColorsTable(foreColors, foreColorIds);

    dropdownInnerHTML += '  <div style="float: left; margin-top: 7px; display: table;">';
    dropdownInnerHTML += '    <div style="display: table-cell; vertical-align: middle;">Hex code #<input type="text" id="idInpColorHexCode" maxlength="6" value="000000" style="position: relative; left: 1px; width: 53px; height: 19px; margin: 0; padding: 0 0 0 3px; border: 1px solid #999999; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; vertical-align: baseline;"></div>';
    dropdownInnerHTML += '    <div style="display: table-cell; vertical-align: middle; padding-left: 4px;"><div id="idPreviewColorHexCode" style="width: 15px; height: 15px; background-color: #000000;"></div></div>';
    dropdownInnerHTML += '  </div>';

    dropdownInnerHTML += '  <div id="idBtnColorHexCodeOk" style="width: 47px; height: 21px; overflow: hidden; float: right; margin-top: 6px; background: transparent url(' + selectColorButton + ') 0 0 no-repeat; cursor: pointer;"></div>';

    dropdownInnerHTML += '  <div id="idColorCellCup" style="position: absolute; left: -3700px; top: -3700px; z-index: 17; width: 15px; height: 15px; overflow: hidden; border: 1px solid #A1D35C; -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.43); -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.43); box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.43); font-size: 0; cursor: crosshair; background: transparent; url(' + BEditor.utils.getZGif() + ') 0 0 repeat;">';
    dropdownInnerHTML += '    <div style="width: 15px; height: 15px; overflow: hidden; background: transparent; url(' + BEditor.utils.getZGif() + ') 0 0 repeat; -moz-box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.43); -webkit-box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.43); box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.43); font-size: 0; cursor: crosshair;"></div>';
    dropdownInnerHTML += '  </div>';

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_Dropdown', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML, null, null, null, null, null, { 'isReload': !!isNewTheme });
    initColorDropdownComponents();
  };


  this.preInitBackColorDropdownButton = (isNewTheme) =>
  {
    const backColors = editorToolbarColorsTable,
          backColorIds = editorToolbarColorsTable;

    let dropdownInnerHTML;

    pButton.pAttribute.parameters.themeColorsContainerId = 'idBackColorDropdownThemeColorsContainer';

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="position: relative; width: 289px; overflow: hidden; padding: 10px 8px 10px 10px; background-color: #F5F5F5; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: normal; font-style: normal; text-decoration: none;">';

    dropdownInnerHTML += '  <div id="' + pButton.pAttribute.parameters.themeColorsContainerId + '" style="overflow: hidden;">';
    dropdownInnerHTML += '    <div style="width: 87px; overflow: hidden; float: left; padding-top: 1px;">' + ((pButton.pAttribute.name === 'BackColorEmail') ? 'Email colors' : 'Theme colors') + '</div>';

    for (let i = 0; i < 12; i++)
    {
      dropdownInnerHTML += '  <div ddtype="Item" ddsubtype="ColorCell" ddvalue="" style="width: 15px; height: 15px; overflow: hidden; float: left; visibility: hidden; margin: 0 1px 1px 0; background: transparent; font-size: 0; cursor: crosshair;"></div>';
    }

    dropdownInnerHTML += '  </div>';

    dropdownInnerHTML += '<div id="' + pButton.pAttribute.parameters.themeColorsContainerId + '_Separator" style="height: 19px; overflow: hidden; margin: 0 -10px; background: transparent url(data:image/gif;base64,R0lGODlhAgABAIABALOzs////yH5BAEAAAEALAAAAAACAAEAAAICDAoAOw==) 0 8px repeat-x;"></div>';

    dropdownInnerHTML += renderColorsTable(backColors, backColorIds);

    dropdownInnerHTML += '  <div style="float: left; margin-top: 7px; display: table;">';
    dropdownInnerHTML += '    <div style="display: table-cell; vertical-align: middle;">Hex code #<input type="text" id="idInpColorHexCode" maxlength="6" value="000000" style="position: relative; left: 1px; width: 53px; height: 19px; margin: 0; padding: 0 0 0 3px; border: 1px solid #999999; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; vertical-align: baseline;"></div>';
    dropdownInnerHTML += '    <div style="display: table-cell; vertical-align: middle; padding-left: 4px;"><div id="idPreviewColorHexCode" style="width: 15px; height: 15px; background-color: #000000;"></div></div>';
    dropdownInnerHTML += '  </div>';

    dropdownInnerHTML += '  <div id="idBtnColorHexCodeOk" style="width: 47px; height: 21px; overflow: hidden; float: right; margin-top: 6px; background: transparent url(' + selectColorButton + ') 0 0 no-repeat; cursor: pointer;"></div>';

    dropdownInnerHTML += '  <div id="idColorCellCup" style="position: absolute; left: -3700px; top: -3700px; z-index: 17; width: 15px; height: 15px; overflow: hidden; border: 1px solid #A1D35C; -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.43); -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.43); box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.43); font-size: 0; cursor: crosshair; background: transparent; url(' + BEditor.utils.getZGif() + ') 0 0 repeat;">';
    dropdownInnerHTML += '    <div style="width: 15px; height: 15px; overflow: hidden; background: transparent; url(' + BEditor.utils.getZGif() + ') 0 0 repeat; -moz-box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.43); -webkit-box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.43); box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.43); font-size: 0; cursor: crosshair;"></div>';
    dropdownInnerHTML += '  </div>';

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_Dropdown', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML, null, null, null, null, null, { 'isReload': !!isNewTheme });
    initColorDropdownComponents();
  };


  this.setColorDropdownThemeColors = () =>
  {
    if (pButton.pAttribute.Dropdown.isObjValid)
    {
      const themeColors = pButton.pAttribute.parameters.themeColors;

      let currentColor,
        container = pButton.pAttribute.Dropdown.get$(pButton.pAttribute.parameters.themeColorsContainerId),
        separator = pButton.pAttribute.Dropdown.get$(pButton.pAttribute.parameters.themeColorsContainerId + '_Separator'),
        elements = container.querySelectorAll('[ddsubtype="ColorCell"]');

      if (themeColors.length > 0)
      {
        container.style.display = 'block';
        separator.style.display = 'block';

        for (let i = 0; i < elements.length; i++)
        {
          if (i < themeColors.length)
          {
            currentColor = (themeColors[i].indexOf('#') !== -1) ? themeColors[i].substr(themeColors[i].indexOf('#') + 1) : themeColors[i];
            elements[i].setAttribute('ddvalue', currentColor);
            elements[i].style.background = '#' + currentColor;
            elements[i].style.visibility = 'visible';
          }
          else
          {
            elements[i].setAttribute('ddvalue', '');
            elements[i].style.background = 'none';
            elements[i].style.visibility = 'hidden';
          }
        }
      }
      else
      {
        container.style.display = 'none';
        separator.style.display = 'none';
      }
    }
    else
    {
      setTimeout(this.setColorDropdownThemeColors, 100)
    }
  };
}